import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783ce8a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swal2-icon swal2-success swal2-icon-show",
  style: {"display":"flex"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "swal2-success-circular-line-left" }),
  /*#__PURE__*/_createElementVNode("span", { class: "swal2-success-line-tip" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "swal2-success-line-long" }),
  /*#__PURE__*/_createElementVNode("div", { class: "swal2-success-ring" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("div", { class: "swal2-success-fix" }),
  /*#__PURE__*/_createElementVNode("div", { class: "swal2-success-circular-line-right" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Thankyou", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "I tuoi fondi sono stati correttamente trasferiti nel wallet #EvoCoinPark", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "container-sticky max-width" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                "size-xl": "9",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _hoisted_3,
                    _hoisted_4,
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectAndRefresh())),
                      size: "large",
                      color: "primary",
                      shape: "round",
                      fill: "none",
                      class: "button-newsletter a-mt-30"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Torna alla Dashboard ")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}